<fieldset>
    <legend>
        <div class="label" (click)="changeVisible()">
            @if (!visible) {
            <mat-icon> add </mat-icon>
            } @if (visible) {
            <mat-icon> remove </mat-icon>
            }
            {{ label }}
        </div>
    </legend>
    <div class="body" [class.opened]="visible">
        <ng-content></ng-content>
    </div>
</fieldset>
